import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.3)_0%,transparent_50%)]"></div>

      <div className="relative max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <i className="ri-smartphone-line text-primary-400 text-xs"></i>
              <span className="text-primary-400 text-xs font-medium">移动端体验</span>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-background-50 mb-4">
              {appData.title}
            </h2>
            <p className="text-lg md:text-xl text-background-200/70 font-heading mb-4">{appData.subtitle}</p>
            <p className="text-sm md:text-base text-background-300/60 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              {appData.desc}
            </p>
            <div className="grid grid-cols-2 gap-3 max-w-md mx-auto lg:mx-0 mb-7">
              {appData.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-5 h-5 rounded-full bg-accent-500/20 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-accent-400 text-xs"></i>
                  </div>
                  <span className="text-sm text-background-200/80 whitespace-nowrap">{f}</span>
                </div>
              ))}
            </div>
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line"></i>
              立即观影
            </a>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative w-[240px] md:w-[280px]">
              <div className="aspect-[9/16] rounded-3xl bg-background-800/60 border-2 border-background-700/40 overflow-hidden">
                <div className="h-full flex flex-col">
                  <div className="h-8 bg-background-700/30 flex items-center justify-center">
                    <div className="w-12 h-1.5 rounded-full bg-background-500/30"></div>
                  </div>
                  <div className="flex-1 p-3 flex flex-col gap-2">
                    <div className="flex-1 rounded-xl bg-background-700/30 flex items-center justify-center relative overflow-hidden">
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-10 h-10 rounded-full bg-primary-500/80 flex items-center justify-center">
                          <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                        </div>
                      </div>
                      <div className="absolute bottom-2 left-2 right-2 h-1 rounded-full bg-background-500/40">
                        <div className="h-full w-3/5 rounded-full bg-primary-500"></div>
                      </div>
                    </div>
                    <div className="space-y-1.5">
                      <div className="h-2.5 rounded bg-background-700/40 w-3/4"></div>
                      <div className="h-2 rounded bg-background-700/30 w-1/2"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-16 h-16 rounded-2xl bg-accent-500 flex items-center justify-center">
                <i className="ri-flashlight-line text-background-950 text-2xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}